export const noteEditCreateForm = [
  {
    type: "select",
    title: "Category",
    dataKey: "category",
    options: [],
  },
  {
    type: "text",
    title: "Note",
    dataKey: "note",
    placeholder: "Not required if you only want to leave a tag.",
  },
];

export const siteCanvassEditCreateForm = [
  {
    type: "text",
    title: "Name",
    dataKey: "name",
    placeholder: "Use something descriptive",
  },
];

export const canvasserEditCreateForm = [
  {
    type: "select",
    title: "Training Only (No emitted data will be saved)",
    dataKey: "is_training",
    options: [
      {
        display: "False",
        value: false,
      },
      {
        display: "True",
        value: true,
      },
    ],
  },
  {
    type: "text",
    title: "First Name",
    dataKey: "firstname",
    placeholder: "Jane",
  },
  {
    type: "text",
    title: "Last Name",
    dataKey: "lastname",
    placeholder: "Smith",
  },
  {
    type: "text",
    title: "Username",
    dataKey: "username",
    placeholder: "Make you sure you have a system for this...",
  },
  {
    type: "text",
    title: "Email",
    dataKey: "email",
    placeholder: "name@example.com",
  },
  {
    type: "text",
    title: "Work phone",
    dataKey: "work_phone",
    placeholder: "Optional",
  },
  {
    type: "text",
    title: "Personal phone",
    dataKey: "personal_phone",
    placeholder: "Optional",
  },
  {
    type: "text",
    title: "Password",
    dataKey: "password",
    placeholder: "Leave blank if you don't want to change this.",
  },
  //you need to add a select box for office based off state.
];

export const genericName = {
  type: "text",
  title: "Name",
  dataKey: "name",
  placeholder: "Use something descriptive",
};

export const genericDescription = {
  type: "text",
  title: "Description",
  dataKey: "description",
  placeholder: "",
};

export const firstName = {
  type: "text",
  title: "First Name",
  dataKey: "first_name",
  placeholder: "Jane",
};

export const lastName = {
  type: "text",
  title: "Last Name",
  dataKey: "last_name",
  placeholder: "Smith",
};

export const username = {
  type: "text",
  title: "Username",
  dataKey: "username",
  placeholder: "Username: No special characters, please",
};

export const passwordField = {
  type: "text",
  title: "Password",
  dataKey: "password",
};

export const addressLine1 = {
  type: "text",
  title: "Address",
  dataKey: "addressline1",
};

export const addressLine2 = {
  type: "text",
  title: "Address Line 2",
  dataKey: "addressline2",
};

export const city = {
  type: "text",
  title: "City",
  dataKey: "city",
};

export const state = {
  type: "select",
  title: "State",
  dataKey: "statecode",
  options: [
    {
      display: "--",
      value: "",
    },
    {
      display: "Alaska",
      value: "AK",
    },
    {
      display: "American Samoa",
      value: "AS",
    },
    {
      display: "Arizona",
      value: "AZ",
    },
    {
      display: "Arkansas",
      value: "AR",
    },
    {
      display: "California",
      value: "CA",
    },
    {
      display: "Colorado",
      value: "CO",
    },
    {
      display: "Connecticut",
      value: "CT",
    },
    {
      display: "Delaware",
      value: "DE",
    },
    {
      display: "District Of Columbia",
      value: "DC",
    },
    {
      display: "Federated States Of Micronesia",
      value: "FM",
    },
    {
      display: "Florida",
      value: "FL",
    },
    {
      display: "Georgia",
      value: "GA",
    },
    {
      display: "Guam",
      value: "GU",
    },
    {
      display: "Hawaii",
      value: "HI",
    },
    {
      display: "Idaho",
      value: "ID",
    },
    {
      display: "Illinois",
      value: "IL",
    },
    {
      display: "Indiana",
      value: "IN",
    },
    {
      display: "Iowa",
      value: "IA",
    },
    {
      display: "Kansas",
      value: "KS",
    },
    {
      display: "Kentucky",
      value: "KY",
    },
    {
      display: "Louisiana",
      value: "LA",
    },
    {
      display: "Maine",
      value: "ME",
    },
    {
      display: "Marshall Islands",
      value: "MH",
    },
    {
      display: "Maryland",
      value: "MD",
    },
    {
      display: "Massachusetts",
      value: "MA",
    },
    {
      display: "Michigan",
      value: "MI",
    },
    {
      display: "Minnesota",
      value: "MN",
    },
    {
      display: "Mississippi",
      value: "MS",
    },
    {
      display: "Missouri",
      value: "MO",
    },
    {
      display: "Montana",
      value: "MT",
    },
    {
      display: "Nebraska",
      value: "NE",
    },
    {
      display: "Nevada",
      value: "NV",
    },
    {
      display: "New Hampshire",
      value: "NH",
    },
    {
      display: "New Jersey",
      value: "NJ",
    },
    {
      display: "New Mexico",
      value: "NM",
    },
    {
      display: "New York",
      value: "NY",
    },
    {
      display: "North Carolina",
      value: "NC",
    },
    {
      display: "North Dakota",
      value: "ND",
    },
    {
      display: "Northern Mariana Islands",
      value: "MP",
    },
    {
      display: "Ohio",
      value: "OH",
    },
    {
      display: "Oklahoma",
      value: "OK",
    },
    {
      display: "Oregon",
      value: "OR",
    },
    {
      display: "Palau",
      value: "PW",
    },
    {
      display: "Pennsylvania",
      value: "PA",
    },
    {
      display: "Puerto Rico",
      value: "PR",
    },
    {
      display: "Rhode Island",
      value: "RI",
    },
    {
      display: "South Carolina",
      value: "SC",
    },
    {
      display: "South Dakota",
      value: "SD",
    },
    {
      display: "Tennessee",
      value: "TN",
    },
    {
      display: "Texas",
      value: "TX",
    },
    {
      display: "Utah",
      value: "UT",
    },
    {
      display: "Vermont",
      value: "VT",
    },
    {
      display: "Virgin Islands",
      value: "VI",
    },
    {
      display: "Virginia",
      value: "VA",
    },
    {
      display: "Washington",
      value: "WA",
    },
    {
      display: "West Virginia",
      value: "WV",
    },
    {
      display: "Wisconsin",
      value: "WI",
    },
    {
      display: "Wyoming",
      value: "WY",
    },
  ],
};

export const zipcode = {
  type: "text",
  title: "Zip Code",
  dataKey: "zipcode",
  placeholder: "10001",
};

export const keyword = {
  type: "text",
  title: "Keyword",
  dataKey: "keyword",
  placeholder: "10001",
};
